export const environment = {
  production: false,

  apiUrl: "https://api-dev.verumai.com/api/v1",
};
